import { createFileRoute } from '@tanstack/react-router';
import UnderDevelopment from '@src/pages/UnderDevelopment';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/team')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('team.page_title', 'Team') }],
  }),
  component: UnderDevelopment,
});
